import { useState, useEffect } from "react";
import { useAgentAccountDetails } from "shared/hooks/common";
import DownArrowChevron from "components/ui/icons/svgs/DownArrowChevron";
import { capitalizeFirstLetterOfWord } from "controllers/common";
import Notifications from "../Notifications";
import ProfileAccountDropdown, { getRoleLabel } from "../ProfileAccountDropdown";

export default function HeaderSideBar({
  handleLogout,
  avatarIcon,
  role,
  userName,
  /*option2,*/ avatarClass,
  sidebarListClick,
  setSidebarListClick,
  email,
  showDeskPortalMenu = false,
  onNavigateToDeskPortal,
}) {
  const { agentRole, agentPhone } = useAgentAccountDetails();
  const [selectedOption1, setSelectedOption1] = useState(role);
  const [selectedOption2, setSelectedOption2] = useState(role);

  useEffect(() => {
    setSelectedOption1(userName);
    setSelectedOption2(agentRole || role);
  }, [userName, role, agentRole]);

  return (
    <div style={{}} className="sidebar-header-container">
      <div className="items-center md:m-0 w-full ">
        <div className="desktop-only  pr-3 ">
          <div className="border border-[rgba(219,218,222,1)] shadow-[1px_2px_4px_0px_rgba(165,163,174,0.3)] rounded-md mt-3 bg-white"></div>
          <div className="relative items-start  mt-3 flex gap-2  w-full">
            <div className="flex items-center gap-2 pt-3">
              <Notifications />
            </div>

            <ProfileAccountDropdown
              handleLogout={handleLogout}
              email={email}
              userName={userName}
              showDeskPortalMenu={showDeskPortalMenu}
              onNavigateToDeskPortal={onNavigateToDeskPortal}
            >
              <div className="flex justify-between items-start gap-2  w-full">
                <div className="flex flex-col justify-start items-start mt-2 cursor-pointer ">
                  <p>{`${capitalizeFirstLetterOfWord(selectedOption1)}`}</p>
                  <p className="text-xs text-[#6e6e6e]">
                    {" "}
                    {` ${process.env.REACT_APP_HM_EXCLUDED_ACC?.includes(agentPhone) ? "AHM" : getRoleLabel(selectedOption2)}`}
                  </p>
                </div>
                <span className="mt-2 pt-1">
                  <DownArrowChevron size={20} color="#6e6e6e" />
                </span>
              </div>
            </ProfileAccountDropdown>
          </div>
        </div>
      </div>
    </div>
  );
}
